import { MoveStruct, normalizeMoveArguments } from "../utils/index.mjs";
import { Balance } from "./balance.mjs";
import { bcs } from "@safecoin/safe/bcs";
//#region src/contracts/0x2/kiosk.ts
/**************************************************************
* THIS FILE IS GENERATED AND SHOULD NOT BE MANUALLY MODIFIED *
**************************************************************/
const $moduleName = "0x2::kiosk";
const Kiosk = new MoveStruct({
	name: `${$moduleName}::Kiosk`,
	fields: {
		id: bcs.Address,
		profits: Balance,
		owner: bcs.Address,
		item_count: bcs.u32(),
		allow_extensions: bcs.bool()
	}
});
const KioskOwnerCap = new MoveStruct({
	name: `${$moduleName}::KioskOwnerCap`,
	fields: {
		id: bcs.Address,
		for: bcs.Address
	}
});
new MoveStruct({
	name: `${$moduleName}::PurchaseCap<phantom T0>`,
	fields: {
		id: bcs.Address,
		kiosk_id: bcs.Address,
		item_id: bcs.Address,
		min_price: bcs.u64()
	}
});
new MoveStruct({
	name: `${$moduleName}::Borrow`,
	fields: {
		kiosk_id: bcs.Address,
		item_id: bcs.Address
	}
});
const Item = new MoveStruct({
	name: `${$moduleName}::Item`,
	fields: { id: bcs.Address }
});
const Listing = new MoveStruct({
	name: `${$moduleName}::Listing`,
	fields: {
		id: bcs.Address,
		is_exclusive: bcs.bool()
	}
});
const Lock = new MoveStruct({
	name: `${$moduleName}::Lock`,
	fields: { id: bcs.Address }
});
new MoveStruct({
	name: `${$moduleName}::ItemListed<phantom T0>`,
	fields: {
		kiosk: bcs.Address,
		id: bcs.Address,
		price: bcs.u64()
	}
});
new MoveStruct({
	name: `${$moduleName}::ItemPurchased<phantom T0>`,
	fields: {
		kiosk: bcs.Address,
		id: bcs.Address,
		price: bcs.u64()
	}
});
new MoveStruct({
	name: `${$moduleName}::ItemDelisted<phantom T0>`,
	fields: {
		kiosk: bcs.Address,
		id: bcs.Address
	}
});
function _new(options = {}) {
	const packageAddress = options.package ?? "0x0000000000000000000000000000000000000000000000000000000000000002";
	return (tx) => tx.moveCall({
		package: packageAddress,
		module: "kiosk",
		function: "new"
	});
}
function place(options) {
	const packageAddress = options.package ?? "0x0000000000000000000000000000000000000000000000000000000000000002";
	const argumentsTypes = [
		null,
		null,
		`${options.typeArguments[0]}`
	];
	return (tx) => tx.moveCall({
		package: packageAddress,
		module: "kiosk",
		function: "place",
		arguments: normalizeMoveArguments(options.arguments, argumentsTypes),
		typeArguments: options.typeArguments
	});
}
function lock(options) {
	const packageAddress = options.package ?? "0x0000000000000000000000000000000000000000000000000000000000000002";
	const argumentsTypes = [
		null,
		null,
		null,
		`${options.typeArguments[0]}`
	];
	return (tx) => tx.moveCall({
		package: packageAddress,
		module: "kiosk",
		function: "lock",
		arguments: normalizeMoveArguments(options.arguments, argumentsTypes),
		typeArguments: options.typeArguments
	});
}
function take(options) {
	const packageAddress = options.package ?? "0x0000000000000000000000000000000000000000000000000000000000000002";
	const argumentsTypes = [
		null,
		null,
		"0x2::object::ID"
	];
	return (tx) => tx.moveCall({
		package: packageAddress,
		module: "kiosk",
		function: "take",
		arguments: normalizeMoveArguments(options.arguments, argumentsTypes),
		typeArguments: options.typeArguments
	});
}
function list(options) {
	const packageAddress = options.package ?? "0x0000000000000000000000000000000000000000000000000000000000000002";
	const argumentsTypes = [
		null,
		null,
		"0x2::object::ID",
		"u64"
	];
	return (tx) => tx.moveCall({
		package: packageAddress,
		module: "kiosk",
		function: "list",
		arguments: normalizeMoveArguments(options.arguments, argumentsTypes),
		typeArguments: options.typeArguments
	});
}
function placeAndList(options) {
	const packageAddress = options.package ?? "0x0000000000000000000000000000000000000000000000000000000000000002";
	const argumentsTypes = [
		null,
		null,
		`${options.typeArguments[0]}`,
		"u64"
	];
	return (tx) => tx.moveCall({
		package: packageAddress,
		module: "kiosk",
		function: "place_and_list",
		arguments: normalizeMoveArguments(options.arguments, argumentsTypes),
		typeArguments: options.typeArguments
	});
}
function delist(options) {
	const packageAddress = options.package ?? "0x0000000000000000000000000000000000000000000000000000000000000002";
	const argumentsTypes = [
		null,
		null,
		"0x2::object::ID"
	];
	return (tx) => tx.moveCall({
		package: packageAddress,
		module: "kiosk",
		function: "delist",
		arguments: normalizeMoveArguments(options.arguments, argumentsTypes),
		typeArguments: options.typeArguments
	});
}
function purchase(options) {
	const packageAddress = options.package ?? "0x0000000000000000000000000000000000000000000000000000000000000002";
	const argumentsTypes = [
		null,
		"0x2::object::ID",
		null
	];
	return (tx) => tx.moveCall({
		package: packageAddress,
		module: "kiosk",
		function: "purchase",
		arguments: normalizeMoveArguments(options.arguments, argumentsTypes),
		typeArguments: options.typeArguments
	});
}
function withdraw(options) {
	const packageAddress = options.package ?? "0x0000000000000000000000000000000000000000000000000000000000000002";
	const argumentsTypes = [
		null,
		null,
		"0x1::option::Option<u64>"
	];
	return (tx) => tx.moveCall({
		package: packageAddress,
		module: "kiosk",
		function: "withdraw",
		arguments: normalizeMoveArguments(options.arguments, argumentsTypes)
	});
}
function borrowVal(options) {
	const packageAddress = options.package ?? "0x0000000000000000000000000000000000000000000000000000000000000002";
	const argumentsTypes = [
		null,
		null,
		"0x2::object::ID"
	];
	return (tx) => tx.moveCall({
		package: packageAddress,
		module: "kiosk",
		function: "borrow_val",
		arguments: normalizeMoveArguments(options.arguments, argumentsTypes),
		typeArguments: options.typeArguments
	});
}
function returnVal(options) {
	const packageAddress = options.package ?? "0x0000000000000000000000000000000000000000000000000000000000000002";
	const argumentsTypes = [
		null,
		`${options.typeArguments[0]}`,
		null
	];
	return (tx) => tx.moveCall({
		package: packageAddress,
		module: "kiosk",
		function: "return_val",
		arguments: normalizeMoveArguments(options.arguments, argumentsTypes),
		typeArguments: options.typeArguments
	});
}
//#endregion
export { Item, Kiosk, KioskOwnerCap, Listing, Lock, _new, borrowVal, delist, list, lock, place, placeAndList, purchase, returnVal, take, withdraw };

//# sourceMappingURL=kiosk.mjs.map